var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-title-container title-font",attrs:{"tabindex":"0","role":"title","aria-label":("dialog title: " + _vm.useTitle)}},[_vm._v("\n\t"+_vm._s(_vm.useTitle)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b5f49ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItems/HeaderTitle.vue
// module id = null
// module chunks = 